export default "__VITE_ASSET__C8lCuEoo__"